import { Box, alpha, useTheme } from '@mui/material';

import SectionBgShape from '../../assets/images/section-bg-shape-1.png';

export default function PageTitle({ children, noBorder }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: alpha(theme.palette.primary.primarylight3, 0.16),
        borderTop: '1px solid',
        borderColor: theme.palette.primary.neutral100,
        borderBottom: '1px solid',
        borderBottomColor: theme.palette.primary.neutral100,
        position: 'relative',
        ...(noBorder && {
          border: 'none',
        }),
        px: 2,
        py: 4,
        minHeight: 180,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        component="img"
        src={SectionBgShape}
        alt=""
        title=""
        sx={{
          position: 'absolute',
          top: 0,
          right: '0',
          transform: 'scaleX(-1)',
          width: { xs: '40%', sm: 'auto' },
          height: 'auto',
          maxWidth: '100%',
        }}
        loading="eager"
      />
      <Box
        component="img"
        src={SectionBgShape}
        alt=""
        title=""
        sx={{
          position: 'absolute',
          top: 0,
          left: '0',
          width: { xs: '40%', sm: 'auto' },
          height: 'auto',
          maxWidth: '100%',
        }}
        loading="eager"
      />
      {children}
    </Box>
  );
}
